import {v4 as uuidv4} from 'uuid';

export const AcUUID = ( prefix?: string) => {
  let result = uuidv4();

  if (prefix) result = `${prefix}-${result}`;

  return result;
};

export default AcUUID;
